import React, { useMemo, useContext } from 'react'
import { Link as RouteLink, useLocation } from 'react-router-dom'

import { Box, Typography, Link, Divider, Breadcrumbs } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { routes } from 'App'
import { ScreenContext } from 'apps/utils/ScreenContext'

const useStyles = makeStyles( () => ( {
	breadcrumbs: {
		'& li': {
			display: 'block',
			marginBottom: 0
		}
	}
} ) )

const Header = () => {
	const classes = useStyles()
	const { isTablet } = useContext( ScreenContext )

	const { pathname } = useLocation()
	const crumbs = useMemo( () => {
		return routes.filter( ( { path } ) => {
			return pathname.includes( path )
		} )
	}, [ pathname ] )

	return (
		<Box
			paddingLeft={ isTablet ? '64px' : '0px' }
			position='fixed'
			left='0'
			right='0'
			bgcolor='var(--bg)'
			zIndex='9'
		>
			<Breadcrumbs
				aria-label='breadcrumb'
				paddingY='10px'
				borderBottom='1px solid var(--line)'
				paddingLeft={ 4 }
				color='var(--line)'
				alignItems='initial'
				separator={ <Divider orientation='vertical' height='20px'/> }
				className={ classes.breadcrumbs }
			>
				{ crumbs && crumbs.map( ( { id, path, name }, key ) => {
					if ( key + 1 === crumbs.length ) {
						return (
							<Box display='flex'>
								<Typography color='text.primary' key={ id }>{ name }</Typography>
							</Box>
						)
					} else {
						return (
							<Link
								key={ id }
								component={ RouteLink }
								to={ path }
								underline='hover'
								color='inherit'
							>
								{ name }
							</Link>
						)
					}
				} ) }
			</Breadcrumbs>
		</Box>
	)
}

export default React.memo( Header )
